// Curated, machine-assisted terminology for the patient navigation and home.
// Keep product branding separate from the personal My Care area.
// These labels require human language review before being described as validated.
export const SECTION_NAMING = Object.freeze({
  en: ['Know Your Journey', 'My Care', 'Understand what may happen during your hospital visit.'],
  pl: ['Poznaj swoją drogę przez leczenie', 'Moja opieka', 'Dowiedz się, co może się wydarzyć podczas wizyty w szpitalu.'],
  ro: ['Cunoaște-ți parcursul', 'Îngrijirea mea', 'Înțelege ce se poate întâmpla în timpul vizitei la spital.'],
  fr: ['Comprendre votre parcours', 'Mes soins', 'Comprenez ce qui peut se passer pendant votre visite à l’hôpital.'],
  es: ['Conoce tu recorrido', 'Mi atención', 'Comprende qué puede ocurrir durante tu visita al hospital.'],
  ar: ['تعرّف على رحلتك العلاجية', 'رعايتي', 'تعرّف على ما قد يحدث خلال زيارتك للمستشفى.'],
  ur: ['اپنے علاج کے سفر کو سمجھیں', 'میری نگہداشت', 'جانیں کہ ہسپتال کے دورے کے دوران کیا ہو سکتا ہے۔'],
  bn: ['আপনার চিকিৎসার যাত্রা সম্পর্কে জানুন', 'আমার যত্ন', 'হাসপাতালে আপনার ভিজিটের সময় কী হতে পারে তা জানুন।'],
  pa: ['ਆਪਣੇ ਇਲਾਜ ਦੇ ਸਫ਼ਰ ਨੂੰ ਜਾਣੋ', 'ਮੇਰੀ ਦੇਖਭਾਲ', 'ਜਾਣੋ ਕਿ ਹਸਪਤਾਲ ਵਿੱਚ ਤੁਹਾਡੀ ਮੁਲਾਕਾਤ ਦੌਰਾਨ ਕੀ ਹੋ ਸਕਦਾ ਹੈ।'],
  so: ['Faham safarkaaga daryeelka', 'Daryeelkayga', 'Faham waxa dhici kara inta aad booqanayso isbitaalka.'],
  pt: ['Conheça o seu percurso', 'Os meus cuidados', 'Compreenda o que pode acontecer durante a sua visita ao hospital.'],
  it: ['Conosci il tuo percorso', 'Le mie cure', 'Scopri cosa potrebbe accadere durante la tua visita in ospedale.'],
  gu: ['તમારી સારવારની સફર જાણો', 'મારી સંભાળ', 'હોસ્પિટલની મુલાકાત દરમિયાન શું થઈ શકે છે તે સમજો.'],
  tr: ['Bakım yolculuğunuzu tanıyın', 'Bakımım', 'Hastane ziyaretiniz sırasında neler olabileceğini öğrenin.'],
  fa: ['با مسیر درمان خود آشنا شوید', 'مراقبت من', 'بدانید در طول مراجعه به بیمارستان چه اتفاقاتی ممکن است رخ دهد.'],
  zh: ['了解您的就医旅程', '我的护理', '了解您在医院就诊期间可能会发生什么。'],
  tl: ['Alamin ang Iyong Paglalakbay sa Pangangalaga', 'Aking Pangangalaga', 'Alamin kung ano ang maaaring mangyari sa iyong pagbisita sa ospital.'],
});

export function sectionNamingResources(language) {
  const [journey, myCare, description] = SECTION_NAMING[language] || SECTION_NAMING.en;
  return {
    nav: { hospitalJourney: journey, myCare },
    home: {
      cards: {
        journey: { title: journey, description },
        myCare: { title: myCare },
      },
    },
    journeyInfo: { title: journey, whatIsTitle: journey },
  };
}

export function installSectionNaming(i18n, language, namespace) {
  const resources = sectionNamingResources(language)[namespace];
  if (resources) i18n.addResourceBundle(language, namespace, resources, true, true);
}
